import React from 'react';
import { RequestInformationPage } from './RequestInformationPage';

// /request-information/v1 — the "v1" template of the Request Information
// flow. It launches as an exact copy of the default experience at
// /request-information and is the surface where v1-only changes land.
//
// To diverge this template from the default flow, branch on
// variant === 'v1' inside RequestInformationPage (or lift the section
// being changed into a prop) so the default route keeps its current
// behavior while v1 evolves independently. Additional templates follow
// the same pattern: one wrapper page per variant.
export function RequestInformationV1Page() {
  return <RequestInformationPage variant="v1" data-id="element-1800" data-mp="2hknpzpxu7olw" />;
}